module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-whyus-photo-00.jpg?h=0697cfd80f74bd7b936b7d3814366845";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-00.jpg
// module id = 2099
// module chunks = 12 15